import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';

import { TabScreenWrapper } from '@components/General/TabScreen';
import QontactPointListadoV1 from '@components/QontactPoints/QontactPointListadoV1';
import QontactPointNuevo from '@components/QontactPoints/QontactPointNuevo';
import { Flap } from '@models/Flap';
import { Organization } from '@models/Organization';
import { useQRMode } from '@hooks/useQRMode';
import QontactPointListScreen from '@screens/QontactPoints/Listado/QontactPointListScreen';

interface QontactPointScreenProps {
    org: Organization;
}

const QontactPointScreen: React.FC<QontactPointScreenProps> = ({org}) => {

    const [clickedScreen, setClickedScreen] = useState<string>('listado')

    // Which QR to show depends on the organization's check-in channel
    const qrMode = useQRMode(org);

    if (!org.newFlags?.QontactPointCreationWeb) {
        return <Navigate to="/" />;
    }

    // Shifts V2 orgs: redesigned list with "Nuevo" as a modal
    if (org.newFlags?.PresenteeismShiftsV2) {
        return <QontactPointListScreen orgID={org.id} isLite={org.newFlags?.LiteVersion} qrMode={qrMode} />;
    }

    const flaps: Flap[] = [
        {
            id: 'listado',
            label: 'Listado',
            content: <QontactPointListadoV1 orgID={org.id} isLite={org.newFlags?.LiteVersion} qrMode={qrMode}/>
        },
        {
            id: 'nuevo',
            label: 'Nuevo',
            content: <QontactPointNuevo orgID={org.id} setClickedScreen={setClickedScreen} />
        },
    ];

    return (
        <TabScreenWrapper
            title="Qontact Points"
            subtitle="Gestion de Qontact Points"
            flaps={flaps}
            flag={org.newFlags?.QontactPointCreationWeb}
            clickedScreen={clickedScreen}
            setClickedScreen={setClickedScreen}
        />
    );

};


export default QontactPointScreen
